/** Has test
 * convert number or string to comma number string format
 * ex: '123456' => '123,456.00'
 * @param {number | string}
 * @param {boolean} showing, decimal point, default 2
 * @param {boolean} decimal string, default '.'
 * @param {boolean} comma string, default ','
 * @param {boolean} true for falsy input return '-'
 * @return {string}
 */
/* eslint-disable */
export function toFormat(n, c, d: string = ".", t: string = ",", showBar: boolean) {
  if (showBar && (!n && n !== 0)) return "-";
  if ((!n && n !== 0) || n === "-") {
    return n;
  }
  var c = isNaN((c = Math.abs(c))) ? 2 : c,
    s = n < 0 ? "-" : "",
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
      Math.abs(n - i)
        .toFixed(c)
        .slice(2)
      : "")
  );
}



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/utils/index.js